import styled from 'astroturf/react'
import { HtmlParser } from '@calendly/html-parser'
import { Button } from '@calendly/ui/components/button'
const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { Segment } from '@calendly/segment'
import { BodyText } from '@calendly/ui/components/typography'

import { useMeetingTypesPath } from 'hooks/use_meeting_types_path'
import { useI18n } from 'locales'
import _Wrapper from "poll_creation_call_to_action-Wrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/poll_creation_call_to_action.js?styleId=Wrapper";
import _StyledButton from "poll_creation_call_to_action-StyledButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/poll_creation_call_to_action.js?styleId=StyledButton";


const Wrapper = /*#__PURE__*/styled('div', null, {
  displayName: "Wrapper",
  styles: _Wrapper
})

const StyledButton = /*#__PURE__*/styled(Button, null, {
  displayName: "StyledButton",
  styles: _StyledButton,
  attrs: props => ({
    ...props,
    as: 'a',
    size: 'large',
    isPhone: useDeviceType('isPhone')
  })
})

export const PollCreationCallToAction = () => {
  const { i18n } = useI18n()
  const meetingTypesRoute = useMeetingTypesPath()
  const createPollRoute = `${meetingTypesRoute}?create_new_meeting=poll`

  const trackPollCreation = () => {
    Segment.track('create_poll_from_confirmation_page')
  }

  return (
    <Wrapper>
      <BodyText level={3}>
        {HtmlParser(i18n.t('booking.templates.signup_form.polls_call_to_action.header'))}
      </BodyText>
      <StyledButton
        onClick={trackPollCreation}
        href={createPollRoute}
      >
        {i18n.t('booking.templates.signup_form.polls_call_to_action.button_text')}
      </StyledButton>
    </Wrapper>
  )
}
